import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import { withTranslation } from 'react-i18next';
import withStyles from '@material-ui/core/styles/withStyles';

// styles
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';

import qs from 'helpers/queryStrings';
import RouterContext from 'helpers/routerContext';
import Button from 'components/UI/CustomButtons/Button';
import WithPermission from 'components/User/WithPermission';
import { RADAR } from 'routes/paths';

class RadarListItemDetail extends React.Component {
  static contextType = RouterContext;

  /**
   * @description
   * Redirect to permission/create route.
   */
  handleNewRule = () => {
    const history = this.context;
    const { initialFilters, routePaths } = this.props;

    const urlString = qs.stringify({
      ...initialFilters,
    });

    history.push({ pathname: routePaths.CREATE, search: urlString });
  };

  /**
   * @description
   * Redirect to permission/create route.
   */
  handleListRule = () => {
    const history = this.context;
    const { initialFilters, routePaths } = this.props;

    const urlString = qs.stringify({
      ...initialFilters,
    });

    history.push({ pathname: routePaths.LIST, search: urlString });
  };

  render() {
    const { classes, t, data } = this.props;
    return (
      <div className={classes.pageContainer}>
        <GridContainer>
          <GridItem xs={12} sm={6}>
            <h3 className={classes.title}>{data.listName}</h3>
          </GridItem>
          <GridItem xs={12} sm={6}>
            <GridContainer justify="flex-end">
              <GridItem>
                <Button
                  color="info"
                  default
                  onClick={this.handleListRule}
                  id="list-rule"
                >
                  {t('radar.list.tile')}
                </Button>

                <WithPermission allowPermissions={['add_processorlistitem']}>
                  <Button
                    color="success"
                    default
                    onClick={this.handleNewRule}
                    id="new-rule"
                  >
                    {t('radar.list.new')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>

        <div className={classes.contentContainer}>
          <GridContainer>
            <GridItem xs={12} sm={6}>
              <h6>{t('radar.list.headers.name')}</h6>
              <p>{data.listName}</p>
            </GridItem>
            <GridItem xs={12} sm={6}>
              <h6>{t('radar.list.headers.group')}</h6>
              <p>{data.group}</p>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6}>
              <h6>{t('radar.list.headers.created')}</h6>
              {data.createdBy ? (
                <p>
                  {data.createdBy.fullname} - {data.createdBy.email}
                </p>
              ) : (
                <i>{t('radar.list.emptyUpdated')}</i>
              )}
            </GridItem>
            <GridItem xs={12} sm={6}>
              <h6>{t('radar.list.headers.updated')}</h6>
              {data.updatedBy ? (
                <p>
                  {data.updatedBy.fullname} - {data.updatedBy.email}
                </p>
              ) : (
                <i>{t('radar.list.emptyUpdated')}</i>
              )}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <h6>{t('radar.list.headers.value')}</h6>
              <p>{data.value}</p>
            </GridItem>
            <GridItem xs={12}>
              <h6>{t('radar.list.headers.description')}</h6>
              <p>{data.description}</p>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

/**
 * RadarListCreate PropTypes
 * @param data - item detail values
 */
RadarListItemDetail.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  initialFilters: PropTypes.shape({}).isRequired,
  routePaths: PropTypes.shape({
    CREATE: PropTypes.string.isRequired,
    LIST: PropTypes.string.isRequired,
  }),
};

RadarListItemDetail.defaultProps = {
  routePaths: RADAR,
};

// to fix: The withStyles HOC set contextTypes to a children component
const RadarUpdateWrapper = props => <RadarListItemDetail {...props} />;

export default withTranslation()(
  withStyles(extendedTablesStyle)(RadarUpdateWrapper),
);
